<span
  *ngIf="props.prefix"
  class="field-input-prefix"
>
  {{ disabled && display === defaultValue ? '' : props.prefix }}
</span>

<input
  [class.field-invalid]="showError"
  [dropSpecialCharacters]="maskConfig.config?.dropSpecialCharacters || false"
  [formControl]="formControl"
  [formlyAttributes]="field"
  [id]="id"
  [mask]="maskConfig.mask"
  [name]="field.key"
  [patterns]="maskConfig.config?.patterns || defaultOptions.props.maskConfig.config.patterns"
  [placeholder]="props.placeholder"
  [portalCyTest]="field.key"
  [readonly]="props.readonly"
  [required]="props.required || false"
  [tabIndex]="props.tabindex"
  [type]="type"
  class="field-input"
/>

<span
  *ngIf="disabled"
  class="whitespace-pre-line"
  >{{ display }}</span
>

<span
  *ngIf="props.suffix"
  class="field-input-suffix"
>
  {{ disabled && display === defaultValue ? '' : props.suffix }}
</span>
